import { exportToExcel } from "../../services/fetch-data.service";
import EsgReportData from "./EsgReportData";
import $ from 'jquery';
import useFetch from "../../hooks/useFetch";
import SocialReportData from "./SocialReportData";
import GovernanceReportData from "./GovernanceReportData";
const EXPORT_ESG_API = 'https://api.suspro.io/api/v1/export-gri'

// $("#datepicker").datepicker({
//     format: "yyyy",
//     viewMode: "years",
//     minViewMode: "years"
// });

const EsgReport = () => {

    const { data, isLoading } = useFetch('export-gri?json_data=true')

    const exportEsgReport = () => {
        exportToExcel(EXPORT_ESG_API, 'esgReport')
    };


    if (isLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">ESG Report</h1>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <div className="btn-group me-2 top-filter">
                            <label >Filter&nbsp;by</label>

                            {/* <input className='form-control date' type="date" /> */}
                            <select class="form-select" aria-label="Default select example">
                                <option selected>2021</option>
                                <option value="1">2022</option>
                                <option value="2">2023</option>
                                <option value="3">2024</option>
                            </select>
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={exportEsgReport}>Export</button>
                        </div>

                    </div>
                </div>


                <div className="esg-report">
                    <h5>Environmental</h5>

                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                {/* <th scope="col">Supplier name</th> */}
                                <th scope="col">Year</th>
                                <th scope="col">Category</th>
                                <th scope="col">Question</th>
                                <th scope="col">Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <EsgReportData data={data} />
                        </tbody>

                    </table>
                </div>

                <div className="esg-report">
                    <h5>Social</h5>

                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                {/* <th scope="col">Supplier name</th> */}
                                <th scope="col">Year</th>
                                <th scope="col">Metric</th>
                                <th scope="col">Question</th>
                                <th scope="col">Value</th>
                                {/* <th scope="col">Sector</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <SocialReportData />
                        </tbody>

                    </table>
                </div>

                <div className="esg-report">
                    <h5>Governance</h5>

                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                {/* <th scope="col">Supplier name</th> */}
                                <th scope="col">Year</th>
                                <th scope="col">Metric</th>
                                <th scope="col">Question</th>
                                <th scope="col">Value</th>
                                {/* <th scope="col">Sector</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <GovernanceReportData />
                        </tbody>

                    </table>
                </div>
            </main>

        </>
    )
}

export default EsgReport;